<template>
    <transition name="fade">
        <div class="vue-modal" v-show="open">
            <transition name="drop-in">
                <div class="vue-modal-inner" v-show="open">
                    <div class="vue-modal-content shadow-lg" style="min-width: 600px; background-color: var(--form-color); color: var(--theme-text-main); border-radius: 15px; padding: 30px;">
                        <slot />
                        <p class="h3 text-seccess fw-bold">Please enter card number</p>
                        <div class="form-group text-start">
                            <label title="Card Number">Card Number</label>
                            <input type="text" name="giftcardnumber" v-on:keyup.enter="checkGiftCard()" class="form-control input-lg" id="giftcardnumber" v-model="giftcardnumber" style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main); text-align: center;" />
                        </div>
                        <br>
                        <div style="display:flex; justify-content: space-between; margin-top: 20px; padding: 0 10px;">
                            <button @click="close" class="btn btn-danger btn-lg" style="min-width: 120px;">Close</button>
                            <button @click="checkGiftCard()" class="btn btn-success btn-lg" style="min-width: 120px;">Check Gift Card</button>
                        </div>
                        
                    </div>
                </div>
            </transition>
            <div class="col-sm-4" style="position:fixed;width:245px;height:300px; min-height: 200px;left:0px;bottom:-80px;margin-left: -10px;margin-right: -10px;">
                <numericpad :onInput="onInput" :onDelete="onDelete" :onReset="onReset" :show="showKeypad"/>
            </div>
        </div>
    </transition>
</template>
<script>
  
import axios from "axios";
import commonServices from "@/shared/commonServices"
import numericpad from "@/components/SimpleKeyboard";

export default {
    mixins: [commonServices],
    name:"GiftCard",
    components:{ numericpad },

    mounted() {
        this.$el.querySelector('#giftcardnumber').focus = true;
    },
    data: function(){
        return {
            giftcardnumber: '',
            giftCardInfos: null,
            showKeypad: true,
        }
    },
    methods:{
        onInput(key) {
            if(key == 11){
                this.giftcardnumber = (this.giftcardnumber + "0");
            }else{
                this.giftcardnumber = (this.giftcardnumber + key);
            }
        },
        onDelete() {
            this.giftcardnumber = this.giftcardnumber.slice(0, this.giftcardnumber.length - 1);
        },
        onReset() {
            this.giftcardnumber = "";
        },
        passGiftCardInfos()
        {
            this.$emit('getGiftCardInfos', this.giftCardInfos)
        },
        checkGiftCard: async function(){
            try{
                //Gift Card API
                let dataURL = this.apiURL+'GiftCard/checkGiftCard';
                let giftCardJson = {"appId":"7", 'giftcardnumber': this.giftcardnumber};
                let response = await axios.post(dataURL, giftCardJson); 
                this.giftCardInfos = response.data;
                this.passGiftCardInfos()
            }
            catch (error){
                console.log(error);
            }
            this.close();
        }
    },
    props:{
        open: {
            type:Boolean,
            required:true
        },
    },
    setup(_, { emit }){
        const close = () => {
            emit('close');
        };

        return { close };
    },
};
</script>
<style scoped>
*,
::before

::after{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
/* .vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
}
.vue-modal-inner {
    max-width: 50%;
    max-height: 50%;
    margin: 2rem auto;
} */

.vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}

.vue-modal-inner {
    max-width: 90%;
    max-height: 90vh;
    margin: 0;
}
.vue-modal-content {
    position: relative;
    background-color: #fff;
    border: 5px solid rgba(0, 0, 0, 0.3);
    background-clip: padding-box;
    border-radius: 1rem;
    padding: 1rem;
    width: 100%;
    height: 100%;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}
.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(50px);
}

</style>
